import axios from 'axios';
import React, { useEffect, useState, useCallback, useRef } from 'react'
import ScrollContainer from 'react-indiana-drag-scroll';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as constant from '../../global/const'
import auth from '../../Helpers/auth'
import { TransparentLoader } from '../Loader/transparentLoader.component';
import CardProducto from './cardProducto.component';

const GridProducto = ({ tipo }) => {

    const [productos, setProductos] = useState([]);

    const CancelToken = axios.CancelToken;
    let source = axios.CancelToken.source();
    const sucursal = useSelector(state => state.page.sucursal);
    const [load, setLoad] = useState(true);
    let history = useHistory();
    let user = JSON.parse(auth.getUsuario())
    let cancel = null;

    //______Consulta__________
    // const getProductos = async () => {
    //     await axios.get(constant.GETPRODUCTOS + "?codigoCliente=0&codigoSku=-1")
    //         .then((response) => {
    //             setProductos(response.data);
    //             setLoad(false);
    //         }).catch((err) => {
    //             console.log(err)
    //         })
    // }
    //Input Prueba
    const input = useRef(null);
    const onClickInput = useCallback(event => {
        if (event.target.tagName === "INPUT") {
        input.current = event.target;
        event.target.focus();
        } else {
        if (input.current) {
            input.current.blur();
            input.current = null;
        }
        }
    }, []);

    const GETPRODUCTOSMASCOMPRADOSOFERTA = async () => {
        let url = "?codigo=" + sucursal.codigo + "&nit=" + sucursal.nit + "&agencia=" + sucursal.agencia + "&correo=" + user.email
        if (tipo == 3) {
            url = constant.GETSUGERIDOS + url
        } else {
            url = constant.GETPRODUCTOSSUGERIDOSMASCOMPRADOS + url + "&tipo=" + tipo
        }
        let config = { cancelToken: source.token }
        await axios.get(url, config)
            .then((response) => {
                setProductos(response.data);
                setLoad(false);
            }).catch((err) => {
                setLoad(false);
                console.log(err)
            })
    }

    useEffect(
        () => {
            setLoad(true);
            sucursal && GETPRODUCTOSMASCOMPRADOSOFERTA()
            return () => {
                source.cancel();
            }
        }, [sucursal, tipo])
    return (
        //https://www.npmjs.com/package/react-indiana-drag-scroll
        //https://es.wikipedia.org/wiki/Licencia_MITS
        <ScrollContainer horizontal={true} hideScrollbars={true} nativeMobileScroll={true} onClick={onClickInput}>
            {
                load
                    ?
                    <TransparentLoader />
                    :
                    productos.length > 0
                        ?
                        <div id="gridProductos" style={
                            {
                                display: "inline-flex",
                                marginTop: "20px",
                                padding: "10px",
                                cursor: "move",
                                userSelect: "none",
                            }
                        }>
                            {
                                productos.map((p, i) => {
                                    return (<CardProducto key={i + p.nombre} producto={p} history={history} />)
                                })
                            }
                        </div>
                        :
                        <div id="gridProductos" style={
                            {
                                alignItems: "center",
                                display: "flex",
                                padding: "5rem 0",
                                justifyContent: "center",
                            }
                        }>
                            <h2>No se han encontrado productos</h2>
                        </div>

            }
        </ScrollContainer>

    )
}

export default GridProducto;